/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Achievement_Perfect_Week_HintInputs */

const en_us2_achievement_perfect_week_hint = /** @type {(inputs: Achievement_Perfect_Week_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every training day of one week`)
};

const pt_br2_achievement_perfect_week_hint = /** @type {(inputs: Achievement_Perfect_Week_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os dias de treino de uma semana`)
};

const es_419_achievement_perfect_week_hint = /** @type {(inputs: Achievement_Perfect_Week_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos los días de entrenamiento de una semana`)
};

const pt_pt2_achievement_perfect_week_hint = /** @type {(inputs: Achievement_Perfect_Week_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todos os dias de treino de uma semana`)
};

const fr_fr2_achievement_perfect_week_hint = /** @type {(inputs: Achievement_Perfect_Week_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous les jours d'entraînement d'une semaine`)
};

const de_de2_achievement_perfect_week_hint = /** @type {(inputs: Achievement_Perfect_Week_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle Trainingstage einer Woche`)
};

const it_it2_achievement_perfect_week_hint = /** @type {(inputs: Achievement_Perfect_Week_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutti i giorni di allenamento di una settimana`)
};

/**
* | output |
* | --- |
* | "Every training day of one week" |
*
* @param {Achievement_Perfect_Week_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const achievement_perfect_week_hint = /** @type {((inputs?: Achievement_Perfect_Week_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Achievement_Perfect_Week_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_achievement_perfect_week_hint(inputs)
	if (locale === "es-419") return es_419_achievement_perfect_week_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_achievement_perfect_week_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_achievement_perfect_week_hint(inputs)
	if (locale === "de-DE") return de_de2_achievement_perfect_week_hint(inputs)
	if (locale === "it-IT") return it_it2_achievement_perfect_week_hint(inputs)
	return en_us2_achievement_perfect_week_hint(inputs)
});
export { achievement_perfect_week_hint as "achievement.perfect_week_hint" }